// frontend/src/utils/postLoginRedirect.js

/**
 * Compute the post-login destination for a user.
 *
 * Mirrors the server-side capability split (`backend/app/api/deps.py`):
 *
 *   - billing tier (user_type ∈ {trial, professional, enterprise})
 *     → eligible for /dashboard
 *   - recommender capability (is_recommender, derived from active
 *     Recommender profile) → eligible for /recommender-dashboard
 *
 * Decision matrix:
 *
 *   tier? | recommender? | destination
 *   ------+--------------+-------------------------------
 *    yes  |     yes      | /dashboard    (business is the default;
 *                                         user can switch via navbar)
 *    yes  |      no      | /dashboard
 *     no  |     yes      | /recommender-dashboard
 *     no  |      no      | /dashboard    (defensive default;
 *                                         ProtectedRoute will gate)
 *
 * Direct links to /recommender-dashboard always work for users with the
 * recommender capability — that gating lives in ProtectedRoute, not here.
 *
 * IMPORTANT: pass the user object from the LOGIN RESPONSE
 * (response.user), not the AuthContext user — at the moment of redirect
 * the context state may still be the previous (or null) user.
 */
const TIER_TYPES = new Set(["trial", "solo", "professional", "enterprise"]);

export const computePostLoginPath = (user) => {
  if (!user) return "/dashboard";

  const hasTier = TIER_TYPES.has(user.user_type);
  const hasRecommender = !!user.is_recommender;

  // Recommender-only accounts go to their dashboard. Everyone else (tier
  // users, including dual-role) defaults to /dashboard. Dual-role users
  // can switch from the navbar.
  if (hasRecommender && !hasTier) return "/recommender-dashboard";
  return "/dashboard";
};
